import { render, staticRenderFns } from "./Event.vue?vue&type=template&id=33936f3b&scoped=true&lang=pug&"
import script from "./Event.vue?vue&type=script&lang=js&"
export * from "./Event.vue?vue&type=script&lang=js&"
import style0 from "./Event.scss?vue&type=style&index=0&id=33936f3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33936f3b",
  null
  
)

export default component.exports